<!-- 区分変更比較ダイアログ -->
<p-dialog
  header=" "
  [modal]="true"
  [(visible)]="categoryChangeFlag"
  styleClass="category-change-dialog"
>
  <div class="content">
    <!-- 主催への変更 -->
    <div *ngIf="'1' == memberKbnId" class="p-d-flex">
      <i class="pi pi-info-circle information"
         Position="top"
         fitContent="true">
      </i>
      <div>
        <label>
          「メンバー」に変更します。
        </label><br>
        <label>
          よろしいですか？
        </label>
      </div>
    </div>
    <!-- メンバーへの変更 -->
    <div *ngIf="'2' == memberKbnId" class="p-d-flex">
      <i class="pi pi-info-circle information"
         Position="top"
         fitContent="true">
      </i>
      <div>
        <label>
          「主催・窓口」に変更します。
        </label><br>
        <label>
          よろしいですか？
        </label>
      </div>
    </div>
  </div>

  <!-- ボタンエリア -->
  <div
    class="p-d-flex p-jc-center button-area"
  >
    <button
      pButton
      type="button"
      label="はい"
      class="button-default-size button1"
      (click)="updateChange()"
    ></button>
    <button
      pButton
      type="button"
      label="いいえ"
      class="button-default-size button2"
      (click)="closeDialog()"
    ></button>
  </div>
</p-dialog>

<!-- 退会ダイアログ -->
<p-dialog
  header=" "
  [modal]="true"
  [(visible)]="withdrawalFlag"
  styleClass="category-change-dialog"
>
  <div class="content">
    <div class="p-d-flex">
      <i class="pi pi-info-circle information"
         Position="top"
         fitContent="true">
      </i>
      <div>
        <label>
          分科会から退会します。
        </label><br>
        <label>
          よろしいですか？
        </label>
      </div>
    </div>
  </div>

  <!-- ボタンエリア -->
  <div
    class="p-d-flex p-jc-center button-area"
  >
    <button
      pButton
      type="button"
      label="はい"
      class="button-default-size button1"
      (click)="doWithdrawal()"
    ></button>
    <button
      pButton
      type="button"
      label="いいえ"
      class="button-default-size button2"
      (click)="closeDialog()"
    ></button>
  </div>
</p-dialog>